/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ThreeDotsLoader from "../components/ThreeDotsLoader";
import { initialState, reducer } from "../components/ReducerComponent";

function PaymentFailed() {
  const navigate = useNavigate();
  const [loadingState, dispatch] = useReducer(reducer, initialState);
  const [isRetrying, setIsRetrying] = useState(false);

  // Function to handle free trial
  const handleFreeTrial = () => {
    localStorage.removeItem("price_id");
    navigate("/script");
  };

  // Function to handle retry payment
  const handleRetryPayment = async () => {
    const priceId = localStorage.getItem("price_id");

    if (!priceId) {
      // If no price_id, navigate to knowledge base
      navigate("/script");
      return;
    }

    setIsRetrying(true);

    try {
      let payload = {
        price_id : priceId
      };
      if (localStorage.getItem("visonsignupplan") == "pay-as-you-go") {
        payload.mode_type = "setup";
        payload.price_id = null;
      }
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/payment/create`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: payload,
      });

      if (!response.data.error && response.data.redirect_url) {
        localStorage.setItem(
          "stripe_vision_session_id",
          response.data.session_id
        );
        // Redirect to the payment page
        window.location.href = response.data.redirect_url;
      } else {
        console.error("Payment creation failed:", response.data);
        dispatch({
          type: "ERROR",
          data: {
            errorMessage: response?.data?.message || "Payment failed",
          },
        });
        setIsRetrying(false);
      }
    } catch (error) {
      console.error("Error creating payment:", error);
      dispatch({
        type: "ERROR",
        data: {
          errorMessage: error?.response?.data?.message || "Payment failed",
        },
      });
      setIsRetrying(false);
    }
  };

  return (
    <>
      <div className="h-screen">
        <img
          className="loginfram w-full h-full absolute z-[-10]"
          src={`${window.location.origin}/images/frame.png`}
          alt="frame png"
        />
        <div className="flex flex-wrap -mx-6l h-screen">
          <div className="w-full md:w-1/2 px-[80px] flex items-center justify-center">
            <div className="w-[560px]">
              <img
                className="w-full"
                src={`${window.location.origin}/images/signin-left.png`}
                alt="signin left png"
              />
            </div>
          </div>
          <div className="w-full md:w-1/2 px-[80px] flex items-center justify-center">
            <div className="w-full max-w-[500px]">
              <div
                className="flex justify-center cursor-pointer mb-6"
                onClick={() => window.open(process.env.REACT_APP_LANDING_URL)}
              >
                <img
                  src={`${window.location.origin}/images/VisonWithOReplaced.png`}
                  width={150}
                  height={50}
                  alt="vision logo png"
                />
              </div>

              {/* Error Icon */}
              <div className="mb-6 flex justify-center">
                <div className="w-20 h-20 bg-[#D73939] rounded-full flex items-center justify-center">
                  <svg
                    className="w-10 h-10 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={3}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </div>
              </div>

              {/* Error Message */}
              <h5 className="font-extrabold text-[40px] text-center mb-4">
                Payment Failed
              </h5>
              <p className="text-center text-[20px] font-semibold mb-8">
                We couldn't process your payment. Don't worry, you can try again
                or continue with our free trial.
              </p>

              {/* Action Buttons */}
              <div className="space-y-4">
                {/* Retry Payment Button */}
                <button
                  onClick={handleRetryPayment}
                  disabled={isRetrying}
                  className="w-full mt-2 justify-center py-2 px-[20px] rounded-[20px] font-semibold bg-gradient-to-r from-[#1A71A7] to-[#9D3784] text-white hover:from-[#9D3784] hover:to-[#1A71A7] text-[20px] transition duration-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                >
                  {isRetrying ? (
                    <div className="flex justify-between items-center w-full">
                      <div></div>
                      <div>Processing Payment</div>
                      <div>
                        <ThreeDotsLoader />
                      </div>
                    </div>
                  ) : (
                    <>
                      <svg
                        className="w-5 h-5 mr-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                        />
                      </svg>
                      Retry Payment
                    </>
                  )}
                </button>

                {/* Free Trial Button */}
                <button
                  onClick={handleFreeTrial}
                  className="w-full my-1 mt-2 justify-center py-2 px-[20px] rounded-[20px] font-semibold border border-[#D73939] text-[#D73939] relative hover:bg-[#D73939] hover:text-[#ffffff] transition duration-700 text-[20px] flex items-center"
                >
                  <svg
                    className="w-5 h-5 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                  </svg>
                  Continue with Free Trial
                </button>
              </div>

              {/* Additional Info */}
              <p className="text-center text-[16px] font-semibold mt-6 text-[#9C9C9C]">
                Need help? Contact our support team for assistance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PaymentFailed;
